import { render, staticRenderFns } from "./editOrderModal.vue?vue&type=template&id=b5fefb1e&"
import script from "./editOrderModal.vue?vue&type=script&lang=js&"
export * from "./editOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports